// Status → StatusChip tone maps, shared by every page that shows the status.

// Operation (OperationList) status, matched on its Persian label: status_int
// is a session delta, not a type code, so it can't identify the row type.
// First match wins; «ثبت نام» also covers «ثبت نام با تعداد جلسات دلخواه»,
// «کسر جلسه» covers both deduction types.
const OPERATION_STATUS_TONES = [
    ['غائب', 'error'],
    ['حاضر', 'success'],
    ['ثبت نام', 'primary'],
    ['جلسه رایگان', 'info'],
    ['کسر جلسه', 'warning'],
    ['موارد ویژه', 'warning'],
    ['مرخصی', 'neutral'],
    ['کنسل', 'neutral'],
];

export function operationStatusTone(label) {
    if (!label) return 'neutral';
    const hit = OPERATION_STATUS_TONES.find(([key]) => label.includes(key));
    return hit ? hit[1] : 'neutral';
}
